import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { QuestionnaireService } from '../services/questionnaire.service';
import { LoaderComponent } from './loader/loader.component';

@NgModule({
    declarations: [LoaderComponent],
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule,
    ],
    exports: [LoaderComponent],
    providers: [QuestionnaireService]
})
export class SharedModule { }
